import { initMap } from '../components/CommunityMap';
import {
  destroyDiscoverMobileHomeCarousel,
  initDiscoverMobileHomeCarousel,
} from '../components/DiscoverHomeCarousel';
import Modal from '../components/Modal';
// import ParallaxHomeHero from '../components/ParallaxHomeHero';

import QuickViewModal from '../components/QuickViewModal';
import initReadMore from '../components/ReadMore';
import SpecLoadMore from '../components/SpecLoadMore';

document.addEventListener('DOMContentLoaded', () => {
  // ParallaxHomeHero();
  initReadMore();
  initDiscoverMobileHomeCarousel();
  QuickViewModal('js-quickview-modal');
  SpecLoadMore('js-home-availability');
  const promoModal = Modal('js-promo-modal');
  promoModal.open();
});

function handleResize(): void {
  destroyDiscoverMobileHomeCarousel();
  initDiscoverMobileHomeCarousel();
}

window.addEventListener('resize', handleResize, { passive: true });

window.addEventListener('load', () => {
  //initialize map
  initMap('js-community-map-info-window').catch(error => {
    console.error('Failed to initialize map:', error);
  });
});
